import { Typography } from '@euler/app/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';

export const NotSetLabel = memo(() => {
  const { rpx } = useResponsiveContext();
  return (
    <Typography.Label
      light
      size={rpx(16)}
      css={`
        color: #ccc;
        line-height: ${rpx(20)}px;
      `}
    >
      未设置
    </Typography.Label>
  );
});
